module.exports = __webpack_public_path__ + "static/media/UserIcon.91942cea.svg";